import React, { createContext, FC, useContext, useMemo } from 'react';

import { AuthContext } from '@/contexts/AuthProvider';

type ProfilePictureContextType = {
  profilePictureUrl: string;
};

const defaultBehaviour: ProfilePictureContextType = {
  profilePictureUrl: ''
};

export const ProfilePictureContext = createContext<ProfilePictureContextType>(defaultBehaviour);

type Props = {
  children: React.ReactNode;
};

export const ProfilePictureProvider: FC<Props> = ({ children }) => {
  const { currentUserData: currentUser } = useContext(AuthContext);

  const value = useMemo(
    () => ({ profilePictureUrl: currentUser?.profilePictureUrl ?? '' }),
    [currentUser]
  );

  return (
    <ProfilePictureContext.Provider value={value}>{children}</ProfilePictureContext.Provider>
  );
};
